import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Alleen voor de clubkiezer na het inloggen (/auth/kies-club): een
 * super-admin, met zijn eigen inlog of in een club die hij opende. Zonder
 * inlog naar het inlogscherm, met een gewone clubinlog naar de app.
 */
export const beheerderGuard = (): boolean => {
  const auth = inject(AuthService);
  if (!auth.token) {
    void inject(Router).navigate(['/auth/login']);
    return false;
  }
  if (!auth.isBeheerderZonderClub && !auth.isBeheerderInClub) {
    void inject(Router).navigate(['/']);
    return false;
  }
  return true;
}
